import React from 'react';

const DataRow = ({ title, data }) => (
    <>
        <div className="text-[6px] md:text-[14px] text-white font-bold leading-tight">
            {title}
        </div>
        {data.map((num, idx) => (
            <div
                key={idx}
                className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
            >
                {num}
            </div>
        ))}
    </>
);

const Section = ({ title, rows }) => (
    <div className="md:mt-8 mt-4">
        <div className="flex md:flex-row items-start gap-1 md:gap-[110px]  mb-3 md:mb-5">
            <div className="]">
                <p className="text-[#F38323] font-bold text-[6px] md:text-[20px] tracking-wide">
                    {title}
                </p>
            </div>
        </div>
        <div className="md:h-[2.5px] h-[1px] bg-white mb-3"></div>
        <div className="overflow-x-auto">
            <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)] md:gap-y-2 gap-y-1 gap-x-1 md:gap-x-2 mt-2 md:mt-3">
                {rows.map((row, idx) => (
                    <DataRow key={idx} title={row.title} data={row.data} />
                ))}
            </div>
        </div>
    </div>
);

const Tranings = () => {
    const trainingData = [
        { title: 'Course 1', data: ['345', '345', '345', '345', '345', '345', '345', '345', '345'] },
        { title: 'Course 2', data: ['2450', '2179', '2340', '3212', '2345', '3450', '2345', '2245', '3145'] },
        { title: 'Course 3', data: ['345', '345', '345', '345', '345', '345', '345', '345', '345'] },
        { title: 'Course 4', data: ['2450', '2179', '2340', '3212', '2345', '3450', '2345', '2245', '3145'] },
        { title: 'Course 5', data: ['345', '345', '345', '345', '345', '345', '345', '345', '345'] },
        { title: 'Course 6', data: ['2450', '2179', '2340', '3212', '2345', '3450', '2345', '2245', '3145'] },
    ];

    const financeData = [
        { title: 'Funding 1', data: ['345', '345', '345', '345', '345', '345', '345', '345', '345'] },
        { title: 'Funding 2', data: ['2450', '2179', '2340', '3212', '2345', '3450', '2345', '2245', '3145'] },
        { title: 'Funding 3', data: ['345', '345', '345', '345', '345', '345', '345', '345', '345'] },
        { title: 'Funding 4', data: ['2450', '2179', '2340', '3212', '2345', '3450', '2345', '2245', '3145'] },
        { title: 'Funding 5', data: ['345', '345', '345', '345', '345', '345', '345', '345', '345'] },
        { title: 'Funding 6', data: ['2450', '2179', '2340', '3212', '2345', '3450', '2345', '2245', '3145'] },
    ];

    return (
        <div className="bg-[#03897B]">
            <div className="mb-3 md:mt-3 mt-1 pt-1 pb-4 md:pt-2 md:pb-14 md:px-24 px-4">
                <Section title="TRAININGS" rows={trainingData} />
                <Section title="FINANCE BENEFICIARIES" rows={financeData} />
            </div>
        </div>
    );
};

export default Tranings;
